import {
    ActionType,
    getAssessmentInfoAction,
    initAssessmentInfoAction,
    updateAssessmentInfoAction
} from "./actions";
import { CareRecipientDetailJson, careRecipientDetailInitialState } from "../../../../domain/assessment/CareRecipientDetail";
import { DiseaseJson } from "../../../../domain/assessment/Disease";
import { OtherDiseasesJson, otherDiseasesInitialState } from "../../../../domain/assessment/OtherDiseases";
import { DiureticJson, diureticInitialState } from "../../../../domain/assessment/Diuretic";
import { createSlice } from "@reduxjs/toolkit";

export type AssessmentInfoState = Readonly<{
    careRecipientDetail: CareRecipientDetailJson,
    sufferedDisease: DiseaseJson[],
    otherSufferedDiseases: OtherDiseasesJson,
    dosingMedicine: DiureticJson,
    initProcess: number,
    updateProcess: number
}>;

const assessmentInfoInitialState: AssessmentInfoState = {
    careRecipientDetail: careRecipientDetailInitialState,
    sufferedDisease: [],
    otherSufferedDiseases: otherDiseasesInitialState,
    dosingMedicine: diureticInitialState,
    initProcess: 0,
    updateProcess: 0
};
const slice = createSlice({
    name: ActionType.base,
    initialState: assessmentInfoInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getAssessmentInfoAction.pending,
                (state) => {
                    state.careRecipientDetail = careRecipientDetailInitialState;
                    state.sufferedDisease = [];
                    state.otherSufferedDiseases = otherDiseasesInitialState;
                    state.dosingMedicine = diureticInitialState;
                    state.initProcess += 1;
                }
            )
            .addCase(
                getAssessmentInfoAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const {
                        careRecipientDetail,
                        sufferedDisease,
                        otherSufferedDiseases,
                        dosingMedicine
                    } = payload;
                    state.careRecipientDetail = careRecipientDetail;
                    state.sufferedDisease = sufferedDisease;
                    state.otherSufferedDiseases = otherSufferedDiseases;
                    state.dosingMedicine = dosingMedicine;
                    state.initProcess -= 1;
                }
            )
            .addCase(
                getAssessmentInfoAction.rejected,
                (state) => {
                    state.initProcess -= 1;
                }
            )
            .addCase(
                updateAssessmentInfoAction.pending,
                (state) => {
                    state.updateProcess += 1;
                }
            )
            .addCase(
                updateAssessmentInfoAction.fulfilled,
                (state) => {
                    state.updateProcess -= 1;
                }
            )
            .addCase(
                updateAssessmentInfoAction.rejected,
                (state) => {
                    state.updateProcess -= 1;
                }
            )
            .addCase(
                initAssessmentInfoAction,
                (state) => {
                    state.careRecipientDetail = careRecipientDetailInitialState;
                    state.sufferedDisease = [];
                    state.otherSufferedDiseases = otherDiseasesInitialState;
                    state.dosingMedicine = diureticInitialState;
                    state.initProcess = 0;
                    state.updateProcess = 0;
                }
            );
    }
});

export const assessmentInfoReducer = slice.reducer;
